import { REGION_CITY_ROWS } from './regionsCatalog';

/** Endonym / local script for country chips (not UI-locale dependent). */
export const COUNTRY_NATIVE_LABEL = {
  VN: 'Việt Nam',
  TH: 'ประเทศไทย',
  PH: 'Philippines',
  ID: 'Indonesia',
  MY: 'Malaysia',
  SG: 'Singapore',
  KH: 'កម្ពុជា',
  MM: 'မြန်မာ',
  KR: '한국',
  JP: '日本',
  CN: '中国',
  TW: '台灣',
  MN: 'Монгол',
  RU: 'Россия',
  KZ: 'Қазақстан',
  UZ: "O'zbekiston",
  IN: 'भारत',
  NP: 'नेपाल',
  LK: 'ශ්‍රී ලංකා',
  AE: 'الإمارات',
  SA: 'السعودية',
  QA: 'قطر',
  KW: 'الكويت',
  BH: 'البحرين',
  OM: 'عُمان',
  AU: 'Australia',
  NZ: 'New Zealand',
  GU: 'Guam',
  MP: 'Saipan',
  US: 'United States',
  CA: 'Canada',
  GB: 'United Kingdom',
  DE: 'Deutschland',
  FR: 'France',
  NL: 'Nederland',
  ES: 'España',
  IT: 'Italia',
  PT: 'Portugal',
  PL: 'Polska',
  CZ: 'Česko',
  TR: 'Türkiye',
  ZA: 'South Africa',
  EG: 'مصر',
  BR: 'Brasil',
  MX: 'México',
  AR: 'Argentina',
  CL: 'Chile',
};

/** City labels in local script where we have them (storage still uses English `pick`). */
const CITY_NATIVE_BY_PICK = {
  'Da Nang': 'Đà Nẵng',
  'Ho Chi Minh': 'TP. Hồ Chí Minh',
  'Hanoi': 'Hà Nội',
  'Hoi An': 'Hội An',
  'Nha Trang': 'Nha Trang',
  'Da Lat': 'Đà Lạt',
  'Hue': 'Huế',
  'Can Tho': 'Cần Thơ',
  Seoul: '서울',
  Busan: '부산',
  Incheon: '인천',
  Jeju: '제주',
  Tokyo: '東京',
  Osaka: '大阪',
  Kyoto: '京都',
  Shanghai: '上海',
  Beijing: '北京',
  Taipei: '台北',
  Bangkok: 'กรุงเทพฯ',
  'Chiang Mai': 'เชียงใหม่',
  Phuket: 'ภูเก็ต',
  Jakarta: 'Jakarta',
  Bali: 'Bali',
  Moscow: 'Москва',
  'Saint Petersburg': 'Санкт-Петербург',
  Singapore: 'Singapore',
};

export function getCountryNativeLabel(code) {
  return COUNTRY_NATIVE_LABEL[code] || code;
}

/**
 * @param {{ pick: string, ko?: string, country: string }} row
 */
export function getCityNativeLabel(row) {
  if (!row) return '';
  if (row.country === 'KR' && row.ko) return row.ko;
  return CITY_NATIVE_BY_PICK[row.pick] || row.pick;
}

export function citiesForCountry(countryCode) {
  return REGION_CITY_ROWS.filter((r) => r.country === countryCode);
}

export function popularCitiesForCountry(countryCode) {
  return citiesForCountry(countryCode).filter((r) => r.popular);
}
